import { useParams } from 'react-router';

import EditMediaContainer from './EditMediaContainer';

const testId = 'edit-media';

const EditMedia = () => {
  const { id } = useParams();
  return <EditMediaContainer id={id} testId={testId} />;
};

export default EditMedia;
